import { render, staticRenderFns } from "./NotificationListener.vue?vue&type=template&id=5c7a2ca8&"
import script from "./NotificationListener.vue?vue&type=script&lang=js&"
export * from "./NotificationListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports